import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../../../shared/my-constants';

@Injectable()
export class CpoePrescriptionService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private AddRecord = webapi + 'temr_visit_prescription/create';
  private GetAllRecordByTimelineList = webapi + 'temr_visit_prescription/getAllRecordByTimelineList';

  constructor(
    private http: Http
  ) {
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByTimelineList(model: any) {
    return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-prescription/cpoe-prescription.service.ts